import { ProductTypeInterested } from "../../api/models";
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from "../utils";

const ACTION_LOAD_BUSINESS_SOURCE_REQUEST =
  "ENTITIES/LOAD_BUSINESS_SOURCE_REQUEST";
const ACTION_LOAD_BUSINESS_SOURCE_SUCCESS =
  "INTENT/LOAD_BUSINESS_SOURCE_SUCCESS";
const ACTION_LOAD_BUSINESS_SOURCE_ERROR = "INTENT/LOAD_BUSINESS_SOURCE_ERROR";

export interface ProductTypeInterestedState {
  ProductTypeInterested: ProductTypeInterested[];
  isLoading?: boolean;
  isLoaded?: boolean;
}

const initialState: ProductTypeInterestedState = {
  ProductTypeInterested: [],
  isLoaded: false,
  isLoading: false,
};

type ProductTypeInterestedRequestActionType = IAction<
  typeof ACTION_LOAD_BUSINESS_SOURCE_REQUEST
>;

type ProductTypeInterestedSuccessActionType = IActionWithPayload<
  typeof ACTION_LOAD_BUSINESS_SOURCE_SUCCESS,
  ProductTypeInterested[]
>;

type ProductTypeInterestedErrorActionType = IAction<
  typeof ACTION_LOAD_BUSINESS_SOURCE_ERROR
>;

type Actions =
  | ProductTypeInterestedRequestActionType
  | ProductTypeInterestedSuccessActionType
  | ProductTypeInterestedErrorActionType;

export const loadProductTypeInterestedRequestAction = (): ProductTypeInterestedRequestActionType => {
  return createAction(ACTION_LOAD_BUSINESS_SOURCE_REQUEST);
};

export const loadProductTypeInterestedSuccessAction = (
  data: ProductTypeInterested[]
): ProductTypeInterestedSuccessActionType => {
  return createActionWithPayload(ACTION_LOAD_BUSINESS_SOURCE_SUCCESS, data);
};

export const loadProductTypeInterestedErrorAction = (): ProductTypeInterestedErrorActionType => {
  return createAction(ACTION_LOAD_BUSINESS_SOURCE_ERROR);
};

// reducer
export const ProductTypeInterestedReducer = (
  state: ProductTypeInterestedState = initialState,
  action: Actions
): ProductTypeInterestedState => {
  switch (action.type) {
    case ACTION_LOAD_BUSINESS_SOURCE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case ACTION_LOAD_BUSINESS_SOURCE_ERROR:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case ACTION_LOAD_BUSINESS_SOURCE_SUCCESS:
      return {
        ...state,
        ProductTypeInterested: action.payload,
        isLoading: false,
        isLoaded: true,
      };
    default:
      return state;
  }
};
